<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.subject_treemaps', 2),
                        href: meta.links.index,
                    },
                    {
                        name: subjectTreemap.title,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <span>{{ subjectTreemap.subject_name }}</span> (<span>{{ subjectTreemap.grade_level_name }}</span
            >)
            <div
                :class="{
                    'text-green-500': subjectTreemap.is_published,
                    'text-gray-400': !subjectTreemap.is_published,
                }"
            >
                <div>
                    {{ subjectTreemap.published_at }}
                </div>
                <div>
                    {{ subjectTreemap.unpublished_at }}
                </div>
            </div>
        </div>

        <div>
            <div class="flex gap-2 items-center">
                <NavLinks :links="meta.navLinks.modes" class="mt-3" />
                <div class="flex flex-wrap gap-x-2">
                    <AppButton
                        element="InertiaLink"
                        :href="group.url"
                        v-for="group in options.groups"
                        :key="group.id"
                        class="flex gap-x-2"
                    >
                        {{ group.name }}

                        <IconCircleCheckFilled class="h-5 w-5 text-indigo-600" v-if="filters.group_id == group.id" />
                    </AppButton>
                </div>
            </div>
        </div>

        <div class="mt-3" v-if="filters.group_id">
            <div class="flex flex-wrap -space-x-1 relative z-0 overflow-hidden mt-3">
                <button
                    v-for="student in options.students"
                    :key="student.id"
                    type="button"
                    :title="student.text"
                    :disabled="form.processing"
                    @click="selectStudent(student)"
                >
                    <img
                        :src="student.avatar_or_default"
                        class="relative z-30 inline-block h-8 w-8 rounded-full ring-2 ring-white"
                        :class="{ 'opacity-50': form.student_id != student.id }"
                        alt=""
                    />
                </button>
            </div>

            <div v-if="treeMapAnalysis">
                <PreviousNextLinks :links="meta.sides" class="mt-5" justify="end" />

                <div class="mt-5">
                    <SubjectTreemapAnalysis :treemap-analysis="treeMapAnalysis">
                        <template #above-table>
                            <div v-if="meta.student" class="mt-3">
                                <div class="flex flex-wrap gap-2 items-center">
                                    <div>
                                        <ZoomableImage :src="meta.student.avatar_or_default">
                                            <img
                                                class="h-16 w-16 rounded-full sm:block"
                                                :src="meta.student.avatar_or_default"
                                                alt="Avatar"
                                            />
                                        </ZoomableImage>
                                    </div>
                                    <div>
                                        {{ meta.student.full_name }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </SubjectTreemapAnalysis>
                </div>
            </div>
        </div>

        <div class="mt-5">
            <div>
                {{ $t('messages.grade_activity') }}
            </div>
            <div class="flex gap-2 mt-1">
                <AppButton v-for="group in meta.links.grade_groups" :key="group.id" :href="group.url" as="InertiaLink">
                    {{ group.name }}
                </AppButton>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import { IconCircleCheckFilled } from '@tabler/icons-vue';
import NavLinks from '../../../../components/NavLinks.vue';
import SmartBreadcrumbs from '../../../../components/SmartBreadcrumbs.vue';
import SubjectTreemapAnalysis from './partials/SubjectTreemapAnalysis.vue';
import ZoomableImage from '../../../../components/ZoomableImage.vue';
import PreviousNextLinks from '../../../../components/PreviousNextLinks.vue';

export default {
    components: {
        PreviousNextLinks,
        ZoomableImage,
        SubjectTreemapAnalysis,
        SmartBreadcrumbs,
        NavLinks,
        IconCircleCheckFilled,
        PanelPage,
        AppButton,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'options', 'filters', 'treeMapAnalysis', 'subjectTreemap'],
    data() {
        return {
            form: this.$inertia.form({
                mode: this.filters.mode,
                group_id: this.filters.group_id,
                student_id: this.filters.student_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.show, {
                preserveScroll: true,
            });
        },
        selectStudent(student) {
            this.form.student_id = student.id;
            this.filter();
        },
    },
};
</script>
